import { ParentMenuProps, SiteRegionTypes } from './MainNavigationMenu'

// export const MainNavigationMenu: MainNavigationMenuProps = {
export const getMainNavigationMenu = (
  parentMenus: ParentMenuProps[],
  siteRegion?: SiteRegionTypes
) => {
  const sectionCTA =
    siteRegion === 'us'
      ? {
          title: 'See how Toast works',
          description:
            'Front of house, back of house, and online seamlessly connect and work in sync.',
          url: '/how-toast-works'
        }
      : null

  return {
    label: 'Toast Homepage',
    logo: '',
    url: '/',
    restaurantUrl: 'https://www.toasttab.com/local?referrer=pos',
    loginUrl: 'https://www.toasttab.com/login',
    demoUrl: '/request-demo',
    parentMenus,
    sectionCTA,
    siteRegion
  }
}
